import api from "../../../core/api";
import { FileModel } from "../../../shared/models/models";
import { Customer } from "../../shared/models/customerModels";
import { ChangeBusinessParameters, ChangeGeneralParameters, ChangeOfficeParameters, ChangePortfolioParameters, ChangeSocialParameters } from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
}

class CustomerSettingsApi {

  getCustomer(): Promise<Customer> {
    return api.get<Customer>(`/v1/customers`, getRequestConfig()).then(x => x.data);
  }

  changeLogoSocials(model: ChangeSocialParameters): Promise<any> {
    return api.put(`/v1/customers/socials`, model, getRequestConfig()).then(() => null);
  }

  changeGeneralDetails(model: ChangeGeneralParameters): Promise<any> {
    return api.put(`/v1/customers/general`, model, getRequestConfig()).then(() => null);
  }

  changeOffice(model: ChangeOfficeParameters): Promise<any> {
    return api.put(`/v1/customers/office`, model, getRequestConfig()).then(() => null);
  }

  changeDescription(description: string): Promise<any> {
    return api.put<string>(
      `/v1/customers/description`,
      JSON.stringify(description),
      { ...getRequestConfig(), headers: { 'Content-Type': 'application/json' } })
      .then(() => null);
  }

  changePortfolio(model: ChangePortfolioParameters): Promise<any> {
    return api.put(`/v1/customers/portfolio`, model, getRequestConfig()).then(() => null);
  }

  changeBusiness(model: ChangeBusinessParameters): Promise<any> {
    return api.put(`/v1/customers/business`, model, getRequestConfig()).then(() => null);
  }

  changeBanner(banner: FileModel | null): Promise<any> {
    return api.put(`/v1/customers/banner`, banner || {}, getRequestConfig()).then(() => null);
  }
}

export default new CustomerSettingsApi();